import { CircleCheck } from "lucide-react";
import { useTranslation } from "react-i18next";
import { generatePath, useHistory } from "react-router-dom";
import routing from "routing";
import {
	type FinishExamData,
	FinishExamDefaultModal,
} from "src/components/Modals/FinishExamModals/FinishExamDefaultModal";
import { ExamTypes } from "src/types/enums";

interface FinishedExamModalViewProps {
	exam: FinishExamData;
	onClose: () => void;
}

export const FinishedExamModalView = ({
	exam,
	onClose,
}: FinishedExamModalViewProps) => {
	const isCourse = !!exam.courseId && exam.type === ExamTypes.COURSE;
	const { t } = useTranslation();
	const history = useHistory();

	const goToHome = () => {
		onClose();

		if (isCourse) {
			history.push(generatePath(routing.paths.course, { id: exam.courseId }));
		} else {
			history.push("/");
		}
	};

	return (
		<FinishExamDefaultModal
			onClose={onClose}
			exam={exam}
			titleText={
				isCourse
					? t("modals.finishedCourseExamView.title")
					: t("modals.finishExam.reviewTitle", "Kończysz przeglądanie")
			}
			info={
				<>
					<CircleCheck className="icon-small icon-success flex-shrink-0" />
					<span>
						{t(
							"modals.finishExam.finishedInfo",
							"Egzamin jest zakończony. Możesz zmienić jego nazwę i wrócić do odpowiedzi w każdej chwili.",
						)}
					</span>
				</>
			}
			primaryText={
				isCourse
					? t("modals.finishedCourseExamView.primaryText")
					: t("modals.finishExam.saveAndExit", "Zapisz i wyjdź")
			}
			onPrimary={goToHome}
		/>
	);
};
